import {Component, Input, OnChanges, OnDestroy} from '@angular/core';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-document-preview',
  imports: [],
  templateUrl: './document-preview.component.html',
  standalone: true,
  styleUrl: './document-preview.component.scss'
})
export class DocumentPreviewComponent implements OnChanges, OnDestroy {
  @Input() base64ForDocument: string = '';
  @Input() extension: string = '';
  @Input() height: string = '600px';
  documentSrc: SafeResourceUrl | SafeUrl | null = null;
  private objectUrl: string | null = null;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnChanges() {
    this.loadDocument();
  }

  ngOnDestroy(): void {
    this.revokeObjectUrl();
  }

  get normalizedExtension(): string {
    return this.extension.replace('.', '').toLowerCase();
  }

  get isPdfPreview(): boolean {
    return this.normalizedExtension === 'pdf';
  }

  get isImagePreview(): boolean {
    return this.normalizedExtension === 'png' || this.normalizedExtension === 'jpg' || this.normalizedExtension === 'jpeg';
  }

  loadDocument() {
    this.revokeObjectUrl();
    this.documentSrc = null;
    if (!this.base64ForDocument) {
      console.error('No base64 provided');
      return;
    }
    const normalizedBase64 = this.normalizeBase64(this.base64ForDocument);
    const byteCharacters = atob(normalizedBase64);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    let blobType = '';
    if (this.isPdfPreview) {
      blobType = 'application/pdf';
    } else if (this.normalizedExtension === 'png') {
      blobType = 'image/png';
    } else if (this.normalizedExtension === 'jpg' || this.normalizedExtension === 'jpeg') {
      blobType = 'image/jpeg';
    }
    if (!blobType) {
      console.error(`Unsupported extension for preview: ${this.extension}`);
      return;
    }

    const blob = new Blob([byteArray], { type: blobType });
    this.objectUrl = URL.createObjectURL(blob);
    this.documentSrc = this.isPdfPreview
      ? this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl)
      : this.sanitizer.bypassSecurityTrustUrl(this.objectUrl);
  }

  private normalizeBase64(base64Document: string): string {
    const trimmed = base64Document.trim();
    const unwrapped = trimmed.startsWith('"') && trimmed.endsWith('"')
      ? trimmed.slice(1, -1)
      : trimmed;
    const withoutPrefix = unwrapped.includes(',')
      ? unwrapped.substring(unwrapped.indexOf(',') + 1)
      : unwrapped;

    return withoutPrefix
      .replace(/\\n/g, '')
      .replace(/\\r/g, '')
      .replace(/\s+/g, '')
      .replace(/-/g, '+')
      .replace(/_/g, '/');
  }

  private revokeObjectUrl(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  }
}
